import React, { Component } from 'react';
import { Form, Modal, Button, Container, Row, Col } from 'react-bootstrap';
import marriageactive from '../../assets/img/seeking/marriageactive.svg';
import Upload from './upload';
import axios from 'axios';
import Facerecognition from '../commoncomponents/facerecognition';
import { Trans } from "react-i18next";   
import "../../config/i18n";
import { withTranslation } from "react-i18next";

class Seeking extends Component {
    constructor(props) {
        super(props);
        this.onSubmitSeeking = this.onSubmitSeeking.bind(this);
        this.state = {
            selectedOptions: '',
            selectedSeeking: null,
            seekings_data: [],
            api_url: localStorage.getItem('api_url'),
            uploadmodal: false,
            facerecognitionmodal: false,
        };
    }

    componentDidMount() {
        axios.get(this.state.api_url+`admindatas`)
        .then(res => {
            const seekings_data = res.data.result.peoplefor;
            this.setState({ seekings_data });   
        });
    }

    toggleOption = option => {
        this.setState({ selectedOptions: option.name });
        this.setState({ selectedId: option.id });
    };

    onSubmitSeeking(e) {
        e.preventDefault();
        if(this.state.selectedOptions === null || this.state.selectedOptions === '') {
            this.setState({ noseeking: 'Please select the any seeking' });
            setTimeout(() => {
                this.setState({
                    noseeking: ''
                });
            }, 2000);
        } else {
            localStorage.setItem('peopleforid', this.state.selectedId);
            this.props.handleClose();
            // this.handleUploadOpenModal();
            this.handleFaceOpenModal();
        }
    }

    handleUploadOpenModal = () => {
        this.setState({ uploadmodal: true });
    }

    handleUploadCloseModal = () => {
        this.setState({ uploadmodal: false });
    }

    handleFaceOpenModal = () => {
        this.setState({ facerecognitionmodal: true });
    }

    handleFaceCloseModal = () => {
        this.setState({ facerecognitionmodal: false });
    }

    render() {
        return (
            <div className="">
                <Modal className="modal_div" show={this.props.showModal} centered>
                    <Form className="" onSubmit={this.onSubmitSeeking}>
                        <Modal.Header>
                            <Modal.Title><Trans i18nKey="Seeking">Seeking</Trans></Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="religion_modal">
                            <div className='seeking_height'>
                                <Container>
                                    <Row className=''>
                                        {this.state.seekings_data.map(seeking => (
                                            <Col md={4} sm={4}>
                                                <div className={`seeking_div ${this.state.selectedOptions === seeking.name ? 'seekingselect' : ''}`} onClick={() => this.toggleOption(seeking)}>
                                                    <div className='seeking_subdiv seeking_imgs'>
                                                        <img src={seeking.icon} alt="img" />
                                                    </div>
                                                    <h4>{seeking.name}</h4>
                                                </div>
                                            </Col>
                                        ))}
                                    </Row>
                                </Container>
                            </div>
                        </Modal.Body>
                        <div className="errorMsg" style={{ paddingLeft: "25px" }}>{this.state.noseeking}</div>
                        <Modal.Footer className="forgot_button_plr">
                            <Button type="submit" className='button_primary'><Trans i18nKey="Next">Next</Trans></Button>
                        </Modal.Footer>
                    </Form>
                </Modal>

                <Upload
                    showModal={this.state.uploadmodal}
                    handleClose={this.handleUploadCloseModal}
                />

                <Facerecognition
                    showModal={this.state.facerecognitionmodal}
                    handleClose={this.handleFaceCloseModal}
                />
            </div>
        );
    }
}

export default Seeking;
